import React from "react";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import PieChart from "components/charts/PieChart";
import Card from "components/card/Card";
import { VSeparator } from "components/separator/Separator";

export default function NotificationPieChart({ acted = 0, pending = 0, total = 0 }) {
    const textColor  = useColorModeValue("secondaryGray.900", "white");
    const cardColor  = useColorModeValue("white", "navy.700");
    const cardShadow = useColorModeValue("0px 18px 40px rgba(112, 144, 176, 0.12)", "unset");
    const mutedColor = useColorModeValue("secondaryGray.600", "whiteAlpha.600");
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

    const actedPct   = total > 0 ? Math.round((acted   / total) * 100) : 0;
    const pendingPct = total > 0 ? Math.round((pending / total) * 100) : 0;

    const chartData    = total > 0 ? [acted, pending] : [1, 0];
    const chartOptions = {
        labels:  ["Gestite", "In attesa"],
        colors:  ["#4318FF", "#6AD2FF"],
        chart:   { width: "50px" },
        states:  { hover: { filter: { type: "none" } } },
        legend:  { show: false },
        dataLabels: { enabled: false },
        hover:   { mode: null },
        plotOptions: {
            pie: {
                donut: { labels: { show: false } },
                expandOnClick: false,
            },
        },
        fill:    { colors: ["#4318FF", "#6AD2FF"] },
        tooltip: { enabled: true, theme: "dark" },
    };

    return (
        <Card align="center" direction="column" w="100%" h="100%" p="0">
            <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor} w="100%">
                <Text color="secondaryGray.900" fontSize="18px" fontWeight="700" lineHeight="100%">
                    Notifiche
                </Text>
                <Text color={mutedColor} fontSize="xs" fontWeight="500">
                    Ultimi 7 giorni
                </Text>
            </Flex>

            <Flex direction="column" align="center" w="100%" px="24px" pt="20px" pb="24px" flex="1">
                <PieChart h="220px" w="100%" chartData={chartData} chartOptions={chartOptions} />

                <Card
                    bg={cardColor}
                    flexDirection="row"
                    boxShadow={cardShadow}
                    w="100%"
                    p="15px"
                    px="20px"
                    mt="15px"
                    mx="auto"
                >
                    <Flex direction="column" py="5px">
                        <Flex align="center">
                            <Box h="8px" w="8px" bg="brand.500" borderRadius="50%" me="4px" />
                            <Text fontSize="xs" color={mutedColor} fontWeight="700" mb="5px">Gestite</Text>
                        </Flex>
                        <Text fontSize="lg" color={textColor} fontWeight="700">
                            {total > 0 ? `${actedPct}%` : "—"}
                        </Text>
                    </Flex>
                    <VSeparator mx={{ base: "30px", xl: "30px" }} />
                    <Flex direction="column" py="5px">
                        <Flex align="center">
                            <Box h="8px" w="8px" bg="#6AD2FF" borderRadius="50%" me="4px" />
                            <Text fontSize="xs" color={mutedColor} fontWeight="700" mb="5px">In attesa</Text>
                        </Flex>
                        <Text fontSize="lg" color={textColor} fontWeight="700">
                            {total > 0 ? `${pendingPct}%` : "—"}
                        </Text>
                    </Flex>
                </Card>
            </Flex>
        </Card>
    );
}
